// dependencies
import React, { useEffect, useState } from "react";

// components
import AddEmployees from "./pages/AddEmployees";
import Main from "./pages/Main";

// hooks
import { useCompanyEngagementSettings, useSetCompanyEngagementSettings } from "../../../../../api/hooks";

// api
import { fetchNewSelectionObject } from "../../../../../api/services";

const ExcludedEmployees = () => {
	const [excludedUsers, setExcludedUsers] = useState<string[]>([]);
	const [page, setPage] = useState("main");

	// gets the company engagement settings
	const { data: companyEngagementSettings } = useCompanyEngagementSettings();
	// set the compny engagement settings
	const { mutate: setCompanyEngagementSettings } = useSetCompanyEngagementSettings();

	const selectionObjectID = companyEngagementSettings?.engagement?.excluded_users_bulk_selection_id || "";

	useEffect(() => {
		const fetchSelectionObject = async () => {
			if (companyEngagementSettings) {
				// If it does not exist, create a new bulk user selection object
				if (!selectionObjectID) {
					const result = await fetchNewSelectionObject();
					setCompanyEngagementSettings({
						...companyEngagementSettings.engagement,
						excluded_users_bulk_selection_id: result?.user_selection_id,
					});
				}
			}
		};
		fetchSelectionObject();
	}, [companyEngagementSettings]);

	return (
		<div className="m-auto max-w-[880px]">
			{page === "main" && (
				<Main setPage={setPage} selectionObjectID={selectionObjectID} excludedUsers={excludedUsers} />
			)}
			{page === "add-employees" && (
				<AddEmployees
					setPage={setPage}
					excludedUsers={excludedUsers}
					setExcludedUsers={setExcludedUsers}
					selectionObjectID={selectionObjectID}
				/>
			)}
		</div>
	);
};

export default ExcludedEmployees;
